import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react";

import Color from "@tool/color";
import { isEmpty, isNumber, round } from "lodash";
import { init } from "echarts";
import { NPlay, PuseIcon } from "@/styled/icon";
import moDemand from "../../../store";
import moIndustry from "../../../store/industry";
import moIndex from "@/page/index/store";

interface IProps {}
interface IState {}
let timer: any = null;

const IndustryHotAmount = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { isMock } = moIndex;
  const [play, setPlay] = useState<boolean>(false);
  const { hotIndustryList, totalHotIndustryList, industryTrendList } =
    moIndustry;
  let chart: any = null;
  let r = 0;
  const colorList = [Color.primary, Color.two, Color.secondary];
  const amountRef = useRef<any>(null);
  const data: any = [];
  let startYear: any = totalHotIndustryList.time_str;
  for (let i = 0; i < hotIndustryList.length; ++i) {
    data.unshift(hotIndustryList[i].amount);
  }
  const yData: any = [];
  hotIndustryList?.forEach((res: any) => {
    yData.unshift(res.industry);
  });

  const render = (type?: any) => {
    if (!type) {
      for (let i = 0; i < data.length; ++i) {
        if (r < industryTrendList.length / hotIndustryList.length) {
          data[i] = industryTrendList[r * hotIndustryList.length + i].amount;
        } else {
          r = 0;
        }
      }
      startYear = industryTrendList[r * hotIndustryList.length].month;
      r++;
    }
    // if (chart) chart.dispose();
    chart = init(amountRef.current);

    const option = {
      color: colorList,
      backgroundColor: Color.fff,
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
        show: true,
        formatter: (parmes: any) => {
          console.log(parmes);
          let htl = `<p  style="font-family: 'Roboto';font-size:16px;font-weight:500;color:${Color.blackColor(
            1
          )}">${parmes[0].seriesName}</p>`;
          parmes?.forEach((element: any, i: number) => {
            htl += `<p style="margin-top:10px;display:flex;
                         justify-content: flex-start;align-items: center;">
                      <span
                        style="display:inline-block;
                        width:10px;height:10px;background:${
                          colorList[element.seriesIndex]
                        };
                        border-radius:50%;margin-right:5px">
                      </span>
                      <span style="font-family: 'Roboto';font-size:12px">${
                        element.name
                      }</span>
                      <span style="margin:0 15px"></span>
                      <span style="font-family: 'Roboto';flex:1;text-align:right;font-size:14px;color:${Color.blackColor(
                        1
                      )}">
                        ${
                          isNumber(element.value)
                            ? Number(round(element.value, 1)).toLocaleString()
                            : "-"
                        }
                      </span>
                   </p>`;
          });
          return htl;
        },
      },
      legend: {
        show: false,
      },
      grid: {
        left: 0,
        right: 60,
        bottom: 0,
        top: 20,
        containLabel: true,
      },
      xAxis: {
        type: "value",
        axisLine: {
          show: false,
          lineStyle: { color: Color.ccc },
        },
        splitNumber: 4,
        axisTick: { show: false },
        axisLabel: {
          show: false,
          formatter: (val: number) => {
            if (val === 0) return 0;
            return `${Number(val).toLocaleString()}`;
          },
          fontSize: 10,
          color: Color.blackColor(0.5),
          fontFamily: "Roboto",
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: Color.blackColor(0.08),
            width: 1,
            type: "dashed",
          },
        },
      },
      yAxis: {
        type: "category",
        inverse: true,
        data: yData,
        axisTick: { show: false },
        axisLine: {
          lineStyle: { color: Color.ec },
        },
        axisLabel: {
          color: Color.blackColor(0.85),
        },
        animationDuration: 300,
        animationDurationUpdate: 300,
      },
      series: [
        {
          realtimeSort: true,
          name: startYear,
          type: "bar",
          barWidth: 14,
          label: {
            show: true,
            fontFamily: "Roboto",
            position: "right",
            formatter: (parme: any) => {
              if (parme.value === 0) return 0;
              return `${round(Number(parme.value), 1).toLocaleString()}`;
            },
          },
          itemStyle: {
            borderRadius: [0, 2, 2, 0],
          },
          data,
        },
      ],
      animationDuration: 0,
      animationDurationUpdate: 300,
      animationEasing: "linear",
      animationEasingUpdate: "linear",
      graphic: {
        elements: [
          {
            type: "text",
            right: 160,
            bottom: 60,
            style: {
              text: startYear,
              font: "bolder 80px monospace",
              fill: "rgba(100, 100, 100, 0.25)",
            },
            z: 100,
          },
        ],
      },
    };
    chart.setOption(option, true);
  };

  useEffect(() => {
    render("init");
    window.addEventListener("resize", render);
    return () => {
      window.removeEventListener("resize", render);
    };
  }, [hotIndustryList]);

  const run = () => {
    setPlay(!play);
    render();
    if (timer) {
      clearInterval(timer);
      timer = null;
    } else {
      clearInterval(timer);
      timer = setInterval(render, 500);
    }
  };

  return (
    <section className="industry-hot-amount-warp">
      <section className="pic-top-warp">
        <p className="pic-title">
          <span>{totalHotIndustryList?.amount?.toLocaleString()}</span>{" "}
          全行业招聘量
        </p>
        <p className="pic-right" onClick={run}>
          {play ? <PuseIcon /> : <NPlay />}
          &nbsp; 查看趋势变化
        </p>
      </section>
      <section
        ref={amountRef}
        className="amount-svg"
        style={{
          backgroundImage: isMock
            ? "url(https://file.smartsalary.cn/web-img%402.0/market/image/ismock.png)"
            : "",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center center",
        }}
      ></section>
    </section>
  );
};

export default observer(IndustryHotAmount);
